import { useCallback } from "react";
import { ContractDto, IfrsValuesDto, useUpdateContractMutation } from "../../../../../../autogen/bff-api";
import { useAppDispatch } from "../../../../../../common/redux/hooks";
import { contractSaved, ContractState } from "../../../../../../common/redux/reducers/contractReducer";

export type EditableIfrsValues = Pick<
  IfrsValuesDto,
  | "startDate"
  | "startDateSecondPeriod"
  | "monthlyPayment"
  | "paymentIntervalInMonths"
  | "contractLengthInMonths"
  | "interestRate"
>;

export const editableIfrsValues = (values: IfrsValuesDto | null | undefined): EditableIfrsValues => ({
  startDate: values?.startDate ?? null,
  startDateSecondPeriod: values?.startDateSecondPeriod ?? null,
  monthlyPayment: values?.monthlyPayment ?? null,
  paymentIntervalInMonths: values?.paymentIntervalInMonths ?? null,
  contractLengthInMonths: values?.contractLengthInMonths ?? null,
  interestRate: values?.interestRate ?? null,
});

export const useSaveIfrsValues = (contractId: string) => {
  const dispatch = useAppDispatch();
  const [updateContract] = useUpdateContractMutation();

  return useCallback(
    async (values: EditableIfrsValues): Promise<ContractDto> => {
      const contract = await updateContract({
        contractId,
        updateContractRequest: {
          ifrsValues: {
            startDate: values.startDate ?? undefined,
            startDateSecondPeriod: values.startDateSecondPeriod ?? undefined,
            monthlyPayment: values.monthlyPayment ?? undefined,
            paymentIntervalInMonths: values.paymentIntervalInMonths ?? undefined,
            contractLengthInMonths: values.contractLengthInMonths ?? undefined,
            interestRate: values.interestRate ?? undefined,
          },
        },
      }).unwrap();
      dispatch(contractSaved(contract as ContractState["contract"]));
      return contract;
    },
    [contractId, dispatch, updateContract]
  );
};
